import { createContext, useContext } from 'react';

interface PopoutTreeContextType {
  isOpen: boolean;
}

const PopoutTreeContext = createContext<PopoutTreeContextType | undefined>(
  undefined
);

export const usePopoutTree = () => {
  const context = useContext(PopoutTreeContext);
  return context;
};
